import axiosClient from "./axiosClient";

const cronApi = {
    getLoginCheck: () => axiosClient.get("crons/loginCheck"),
    getLoginCheckOne: (userId) => axiosClient.get(`crons/loginCheckOne/${userId}`),
};

export default cronApi;
